require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-501-ar-development-for-microsoft-hololens.json") })
        }
      }, "path---courses-code-501-ar-development-for-microsoft-hololens");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-501-ar-development-for-microsoft-hololens!./.cache/json/courses-code-501-ar-development-for-microsoft-hololens.json
// module id = 1177
// module chunks = 231608221292675